import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Modal, UiCoreModule } from '@softline/ui-core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Kopfau } from '../../types/kopfau';
import { CurrencyPipe, NgIf } from '@angular/common';

@Component({
    selector: 'soft-change-price',
    templateUrl: './change-price.component.html',
    styleUrls: ['./change-price.component.scss'],
    imports: [
        CurrencyPipe,
        NgIf,
        ReactiveFormsModule,
        UiCoreModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangePriceComponent implements OnInit, Modal<number | undefined> {

  close!: (result: number | undefined) => void;
  price!: number;
  preisebene?: Kopfau['preisebene'];

  @ViewChild('priceInput', { static: true })
  private priceInput?: ElementRef<HTMLInputElement>;

  readonly form = this.fb.group({
    price: [null as string | null, [Validators.required, Validators.min(0)]]
  });

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    if (this.price !== 0 && this.price !== null && this.price !== undefined) {
      const formattedPrice = this.price.toString().replace('.',',');
      this.form.patchValue({ price: formattedPrice });
    }

    if (this.priceInput && this.priceInput.nativeElement) {
      this.priceInput.nativeElement.focus();
    }
  }

  registerCloseHandler(handler: (result: number | undefined) => void) {
    this.close = handler
  }

  closeDialog() {
    const priceInput = this.form?.value?.price ?? '';
    const price = typeof priceInput === 'string' ? +priceInput.replace(',', '.') : +priceInput;

    if (isNaN(price) || price === null || price === undefined)
      this.close(undefined);

    this.close(price ?? 0)
  }
}
